import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import SBUService from "../../services/SBUService";
import { Mode } from "./SBUPage";
import { createAutocompleteOptions } from "../../utility/utils";
import { fetchSBUs } from "../../redux/actions/SBUActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { SBUModel } from "../../models/SBUModel";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  sbuUserId: Yup.number().min(1, "Required").required("Requierd"),
  sbuviewers: Yup.array().notRequired(),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: SBUModel;
};

const SBGForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      sbuUserId: 0,
      sbuviewers: [],
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);
  const allUsers = useAppSelector((state) =>
    state.user.all_Users.filter((rec) => rec.roleId === 3)
  );

  const userOptions = useMemo(() => {
    return createAutocompleteOptions(
      allUsers,
      "userId",
      "firstName",
      "lastName"
    );
  }, [allUsers]);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        sbuUserId: data.sbuuserId,
        sbuviewers: data.sbuviewers
          ? data.sbuviewers.split(",").map((val) => +val)
          : [],
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: SBUModel = {
        sbuid: 0,
        name: "",
        description: "",
        sbuuserId: 0,
        sbuviewers: "",
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        formData.sbuuserId = values.sbuUserId;
        formData.sbuviewers = values.sbuviewers?.length
          ? values.sbuviewers?.join(",")
          : "";
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          sbuuserId: values.sbuUserId,
          sbuviewers: values.sbuviewers?.length
            ? values.sbuviewers?.join(",")
            : "",
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await SBUService.createSBU(formData, data?.sbuid);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchSBUs());
      displayToast(
        `SBU ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Name"
                placeholder="Enter Name"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              <FormikControl
                control="autocomplete"
                options={userOptions}
                name="sbuUserId"
                size="small"
                label="SBU User"
                placeholder="Select SBU User"
              />
              <FormikControl
                control="autocomplete"
                options={userOptions}
                name="sbuviewers"
                multiple={true}
                size="small"
                label="Select SBU Viewers"
                placeholder="Select SBU Viewers"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default SBGForm;
